import _ from 'lodash';
import moment from 'moment';
import React from 'react';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';
import { withRouter } from 'react-router-dom';
import {
  DropdownItem, DropdownMenu, DropdownToggle, UncontrolledButtonDropdown,
} from 'reactstrap';
import SweetAlert from 'react-bootstrap-sweetalert';
import { generateManualWaybill } from '../../../app/store/actions/waybills';
import {
  getListOutboundOrderProducts, getOutboundOrderWithManualWaybillByDate,
} from '../../../app/store/actions/outboundOrders';
import addNotification from '../../../components/notification';
import { Panel } from '../../../components/panel/panel';
import Table from '../../../components/table/Table';
import OutboundProductsTable from './outboundProductsTable';
import ROUTES from '../../../config/routes';

import { generateReport } from '../../../app/store/actions/reports';
import OneClickButton from '../../../components/form/button';

import WaybillsHelpers from '../../../helpers/waybills';
import Select from '../../../components/form/select';
import { getCarriersOptions } from '../../../app/store/actions/carriers';

class ManualWaybillMonitor extends React.Component {
  constructor(props) {
    super(props);

    this.breadcrumb = [
      {
        value: (
          <>
            <i className="fas fa-home fa-fw m-t-10 m-r-5" />
            {' '}
            {I18n.t('BEE12' /* Início */)}
          </>
        ),
      },
      { value: I18n.t('BEE1400' /* Movimentação */) },
      { value: I18n.t('BEE41' /* Expedição */) },
      { value: I18n.t('BEE4650' /* Romaneio Manual */), active: true },
    ];

    this.tableColumns = [
      {
        Header: I18n.t('BEE436' /* Selecionar */),
        accessor: 'action',
        style: { alignSelf: 'center', textAlign: 'center' },
        filterable: false,
        sortable: false,
        width: 100,
        Cell: (row) => (
          <div style={{ textAlign: 'center' }}>
            <input
              type="checkbox"
              checked={this.state.checkedOutboundOrders[row.original.outboundOrderId] || false}
              onChange={() => this.singleSelection(row.original)}
            />
          </div>
        ),
      }, {
        Header: I18n.t('BEE55' /* Ações */),
        accessor: 'action',
        style: { overflow: 'visible', alignSelf: 'center' },
        filterable: false,
        sortable: false,
        width: 100,
        Cell: (row) => (
          <div style={{ textAlign: 'center' }}>
            <button type="button" className="btn btn-default btn-xs">
              {I18n.t('BEE55' /* Ações */)}
            </button>
            <UncontrolledButtonDropdown>
              <DropdownToggle color="default" caret className="btn-xs" />
              <DropdownMenu>
                {row.original.waybillNumber ? (
                  <DropdownItem onClick={() => this.onGenerateWaybillPDF(row.original)}>
                    {I18n.t('BEE3204' /* Imprimir Romaneio */)}
                  </DropdownItem>
                ) : (
                  <DropdownItem onClick={() => this.prepareGenerateManualWaybill(row.original)}>
                    {I18n.t('BEE4653' /* Gerar Romaneio */)}
                  </DropdownItem>
                )}
              </DropdownMenu>
            </UncontrolledButtonDropdown>
          </div>
        ),
      }, {
        Header: I18n.t('BEE1378' /* Documento */),
        accessor: 'orderNumber',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 100,
      }, {
        Header: I18n.t('BEE145' /* Filial */),
        accessor: 'branchCode',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 100,
      }, {
        Header: I18n.t('BEE2997' /* Tipo de Documento */),
        accessor: 'orderType',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 150,
      }, {
        Header: I18n.t('BEE402' /* Nota Fiscal */),
        accessor: 'invoiceNumber',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 150,
      }, {
        Header: I18n.t('BEE50' /* Cliente */),
        accessor: 'customerCode',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 120,
      }, {
        Header: I18n.t('BEE27' /* Produtos */),
        accessor: 'productsCount',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 120,
      }, {
        Header: I18n.t('BEE405' /* Volumes */),
        accessor: 'totalVolumes',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 120,
      },
      {
        Header: I18n.t('BEE907' /* Romaneio */),
        accessor: 'waybillNumber',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 120,
      },
      {
        Header: I18n.t('BEE2615' /* Impresso */),
        accessor: 'waybillPrintedLabel',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 120,
        Filter: ({ onChange }) => (
          <select
            type="text"
            style={{ width: '100%' }}
            onChange={(event) => { onChange(event.target.value); }}
          >
            <option value="">{I18n.t('BEE793' /* Todos */)}</option>
            {WaybillsHelpers.waybillPrintedStatus().map((el) => (
              <option
                key={el.value}
                value={el.label}
              >
                {el.label}
              </option>
            ))}
          </select>
        ),
      },
    ];

    this.state = {
      outboundOrdersList: [],
      selectedOutboundOrder: null,
      checkedOutboundOrders: {},
      defaultPageSize: 10,
      defaultSorted: [{ id: 'orderNumber', desc: false }],
      startDate: moment().subtract(30, 'd'),
      endDate: moment(),
      showCarrierDialog: false,
      carrierCode: null,
      carriersOptions: [],
      showPrintWaybillDialog: false,
      waybill: null,
      showGenerateWaybillDialog: false,
      pendingGenerateOrders: null,
    };
  }

  componentDidMount() {
    this.getOutboundOrderWithManualWaybillByDate();
  }

  prepareGenerateManualWaybill = async (singleOrder = null) => {
    const { checkedOutboundOrders, outboundOrdersList, carrierCode } = this.state;
    const selectedOrders = singleOrder
      ? [singleOrder]
      : outboundOrdersList.filter((order) => checkedOutboundOrders[order.outboundOrderId]);
    if (selectedOrders.length === 0) return;
    const ordersWithoutInvoice = selectedOrders.filter((order) => !order.invoiceNumber);
    if (ordersWithoutInvoice.length > 0) {
      addNotification(
        'danger',
        I18n.t('BEE4650'),
        I18n.t(
          'BEE3032',
          { 0: ordersWithoutInvoice.map((o) => o.orderNumber).join(', ') },
          /* Documento de Saída %{0} sem Nota Fiscal */
        ),
        'top-right',
      );
      return;
    }
    const sameCarrier = new Set(selectedOrders.map((order) => order.carrierCode)).size === 1;
    if (!sameCarrier && !carrierCode) {
      const carriersOptions = await this.props.getCarriersOptions();
      this.setState({ carriersOptions, showCarrierDialog: true });
      return;
    }
    this.setState({ showGenerateWaybillDialog: true, pendingGenerateOrders: selectedOrders });
  };

  confirmGenerateManualWaybill = async () => {
    const { pendingGenerateOrders, carrierCode } = this.state;
    this.setState({ showGenerateWaybillDialog: false, pendingGenerateOrders: null });

    const selectedOrders = pendingGenerateOrders;
    const sameCarrier = new Set(selectedOrders.map((o) => o.carrierCode)).size === 1;
    const carrier = sameCarrier ? selectedOrders[0].carrierCode : carrierCode?.value;
    const { branchCode } = selectedOrders[0];
    const outboundOrderIds = selectedOrders.map((o) => o.outboundOrderId);

    const result = await this.props.generateManualWaybill(outboundOrderIds, branchCode, carrier);
    if (result && result.success === false) {
      addNotification('danger', I18n.t('BEE4650'), I18n.t('BEE4652'), 'top-right');
    } else if (result) {
      addNotification('success', I18n.t('BEE4650'), I18n.t('BEE3372', { 0: result.waybillNumber }), 'top-right');
      this.setState({ showPrintWaybillDialog: true, waybill: result });
      await this.getOutboundOrderWithManualWaybillByDate();
    }
  };

  onGenerateWaybillPDF = async (waybill) => {
    const { location } = this.props;
    const idWaybillPDF = waybill.id || waybill.waybillId;

    await this.props.generateReport(
      I18n.t('BEE4650' /* Romaneio Manual */),
      'pdf',
      location.pathname,
      [{}],
      { id: idWaybillPDF },
    );

    await this.getOutboundOrderWithManualWaybillByDate();
    this.setState({ showPrintWaybillDialog: false, waybill: null });
  };

  getOutboundOrderWithManualWaybillByDate = async () => {
    const { startDate, endDate } = this.state;

    try {
      const outboundOrdersList = await this.props.getOutboundOrderWithManualWaybillByDate(
        moment(startDate).format(),
        moment(endDate).format(),
      );

      if (outboundOrdersList.length > 0) {
        const mappedList = outboundOrdersList.map((order) => ({
          ...order,
          waybillPrintedLabel: WaybillsHelpers.waybillPrintedStatus(order.waybillPrinted ?? 0),
        }));
        this.setState({ outboundOrdersList: mappedList });
      }

      if (outboundOrdersList && outboundOrdersList.success === false) {
        addNotification(
          'danger',
          I18n.t('BEE4650' /* Romaneio Manual */),
          I18n.t('BEE3238' /* Nenhum Romaneio de Carga foi localizado */),
          'top-right',
        );
      }
    } catch (error) {
      const messageError = error.response && error.response.data
        && error.response.data.error && error.response.data.error.message;

      if (messageError) addNotification('danger', I18n.t('BEE4650' /* Romaneio Manual */), messageError, 'top-right');
      else {
        addNotification(
          'danger',
          I18n.t('BEE4650' /* Romaneio Manual */),
          I18n.t('BEE3238' /* Nenhum Romaneio de Carga foi localizado */),
          'top-right',
        );
      }
    }
  };

  handleDateApplyEvent = async (event) => {
    await this.setState({
      startDate: event[0],
      endDate: event[1],
    });

    this.getOutboundOrderWithManualWaybillByDate();
  };

  singleSelection = (order) => {
    const { checkedOutboundOrders } = this.state;
    const nextChecked = { ...checkedOutboundOrders };
    const id = order.outboundOrderId;

    if (nextChecked[id]) {
      delete nextChecked[id];
    } else {
      nextChecked[id] = true;
    }

    this.setState({ checkedOutboundOrders: nextChecked });
  };

  hasWaybill = () => {
    const { checkedOutboundOrders, outboundOrdersList } = this.state;
    const selectedOrders = outboundOrdersList.filter(
      (order) => checkedOutboundOrders[order.outboundOrderId],
    );
    if (selectedOrders.length === 0) {
      return false; // nada selecionado → desabilitado
    }
    return !selectedOrders.some(
      (order) => order.waybillId || order.waybillNumber,
    );
  };

  multipleSelection = (selectionOption) => {
    const { checkedOutboundOrders } = this.state;
    const resolvedState = this.reactTable.getResolvedState();
    const data = resolvedState.sortedData || [];

    const nextChecked = { ...checkedOutboundOrders };

    data.forEach((row) => {
      const id = row._original.outboundOrderId;
      if (selectionOption) {
        nextChecked[id] = true;
      } else {
        delete nextChecked[id];
      }
    });

    this.setState({ checkedOutboundOrders: nextChecked });
  };

  outboundOrderProducts = async (selectedOutboundOrder) => {
    const outboundOrderProducts = await this.props.getListOutboundOrderProducts(selectedOutboundOrder.outboundOrderId);
    this.setState({
      selectedOutboundOrder,
      outboundOrderProducts,
    });
  };

  render() {
    const {
      defaultPageSize,
      defaultSorted,
      outboundOrdersList,
      selectedOutboundOrder,
      outboundOrderProducts,
      showCarrierDialog,
      carrierCode,
      carriersOptions = [],
      showPrintWaybillDialog,
      waybill,
      showGenerateWaybillDialog,
    } = this.state;

    return (
      <>
        <Table
          breadcrumb={this.breadcrumb}
          headerTitle={I18n.t('BEE4650' /* Romaneio Manual */)}
          wikiHelp={ROUTES.MANUAL_WAYBILL_MONITOR_HELP}
          downloadCSV
          panelHeaderProps={{
            onClickReload: this.getOutboundOrderWithManualWaybillByDate,
            children: I18n.t('BEE462' /* Documentos */).toUpperCase(),
          }}
          datePicker={{
            handleDateApplyEvent: this.handleDateApplyEvent,
          }}
          filterable
          expander
          downButtonPosition
          actionButtons={(
            <div
              className="d-flex flex-wrap justify-content-between align-items-center mb-2"
              style={{ marginLeft: 'auto' }}
            >
              <button
                type="button"
                className="btn btn-120 btn-secondary p-5 m-3"
                onClick={() => this.multipleSelection(true)}
              >
                {I18n.t('BEE1908' /* Marcar Todos */)}
              </button>
              <button
                type="button"
                className="btn btn-120 btn-secondary p-5 m-3"
                onClick={() => this.multipleSelection(false)}
              >
                {I18n.t('BEE1909' /* Desmarcar Todos */)}
              </button>

              <OneClickButton
                type="button"
                className="btn btn-140 btn-primary p-5 m-3"
                disabled={!this.hasWaybill()}
                onClick={() => this.prepareGenerateManualWaybill()}
              >
                {I18n.t('BEE4653' /* Gerar Romaneio */)}
              </OneClickButton>
            </div>
          )}
          data={outboundOrdersList}
          columns={this.tableColumns}
          ref={(r) => { this.reactTable = r && r.reactTable; }}
          defaultPageSize={defaultPageSize}
          defaultSorted={defaultSorted}
          defaultFilterMethod={(filter, row) => {
            const input = _.lowerCase(filter.value);
            const value = _.lowerCase(row[filter.id]);
            if (_.includes(value, input)) {
              return true;
            }
          }}
          getTrProps={(state, rowInfo) => {
            if (rowInfo && rowInfo.row) {
              return {
                onClick: async () => {
                  await this.outboundOrderProducts(rowInfo.original);
                },
                style: {
                  background:
          selectedOutboundOrder
            && rowInfo.original.outboundOrderId === selectedOutboundOrder.outboundOrderId
            ? 'silver'
            : 'white',
                  cursor: 'pointer',
                },
              };
            }
            return {};
          }}
        />
        <Panel>
          <OutboundProductsTable
            getOutboundOrderWithManualWaybillByDate={() => this.getOutboundOrderWithManualWaybillByDate()}
            outboundOrderProducts={outboundOrderProducts}
          />
        </Panel>

        {(showCarrierDialog
          && (
          <SweetAlert
            showCancel
            cancelBtnText={I18n.t('BEE99' /* Cancelar */)}
            confirmBtnText={I18n.t('BEE1849' /* Continuar */)}
            confirmBtnBsStyle="primary"
            cancelBtnBsStyle="default"
            title={I18n.t('BEE3700' /* Informe o código da transportadora */)}
            onConfirm={() => ((!carrierCode)
              ? addNotification(
                'danger',
                I18n.t('BEE301' /* Transportadora */),
                I18n.t('BEE3427' /* Código da transportadora inválido */),
                'top-right',
              )
              : (this.setState(
                { showCarrierDialog: false, carrierCode },
                async () => {
                  await this.prepareGenerateManualWaybill();
                },
              ))
            )}
            onCancel={() => this.setState({ showCarrierDialog: false, carrierCode: null })}
          >
            <div className="mt-4">
              <Select
                options={carriersOptions}
                value={carrierCode}
                onChange={(selected) => this.setState({ carrierCode: selected })}
                placeholder={I18n.t('BEE301' /* Transportadora */)}
                isClearable
              />
            </div>
          </SweetAlert>
          ))}

        {(showPrintWaybillDialog
          && (
            <SweetAlert
              warning
              showCancel
              cancelBtnText={I18n.t('BEE173' /* Não */)}
              confirmBtnText={I18n.t('BEE172' /* Sim */)}
              confirmBtnBsStyle="primary"
              cancelBtnBsStyle="default"
              title={I18n.t('BEE4650' /* Romaneio Manual */)}
              onConfirm={async () => { await this.onGenerateWaybillPDF(waybill); }}
              onCancel={() => { this.setState({ showPrintWaybillDialog: false }); }}
            >
              {
                I18n.t(
                  'BEE4654',
                  /* Deseja imprimir o romaneio gerado? */
                )
              }
            </SweetAlert>
          )
        )}

        {showGenerateWaybillDialog && (
        <SweetAlert
          warning
          showCancel
          cancelBtnText={I18n.t('BEE99' /* Cancelar */)}
          confirmBtnText={I18n.t('BEE172' /* Sim */)}
          confirmBtnBsStyle="primary"
          cancelBtnBsStyle="default"
          title={I18n.t('BEE4650' /* Romaneio Manual */)}
          onConfirm={async () => { await this.confirmGenerateManualWaybill(); }}
          onCancel={() => this.setState({ showGenerateWaybillDialog: false, pendingGenerateOrders: null })}
        >
          {I18n.t('BEE4660' /* Deseja gerar o romaneio para os documentos selecionados? */)}
        </SweetAlert>
        )}
      </>
    );
  }
}

const mapStateToProps = () => ({});

const mapDispatchToProps = (dispatch) => ({
  getOutboundOrderWithManualWaybillByDate: (
    filterStartDate,
    filterEndDate,
  ) => dispatch(getOutboundOrderWithManualWaybillByDate(
    filterStartDate,
    filterEndDate,
  )),
  getListOutboundOrderProducts: (outboundOrderId) => dispatch(getListOutboundOrderProducts(outboundOrderId)),
  generateReport: (
    nameDoc,
    type,
    route,
    columns,
    filters,
  ) => dispatch(generateReport(nameDoc, type, route, columns, filters, true)),
  generateManualWaybill: (outboundOrderIds, branchCode, carrierCode) => dispatch(generateManualWaybill(
    outboundOrderIds,
    branchCode,
    carrierCode,
  )),
  getCarriersOptions: () => dispatch(getCarriersOptions()),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ManualWaybillMonitor));
